function hintsInit(){

    $('.hint, .hints').each((index, item) => {

        if ($(item).hasClass('tooltipstered')) return;

        $(item).tooltipster({triggerOpen: {touchstart: true}});

    })

    $('.hint_user').each((index, item) => {

        if ($(item).hasClass('tooltipstered')) return;

        $(item).tooltipster({interactive: true, offsetY: -12});

    })

    $('[data-hint_load]').each((index, item) => {

        if($(item).hasClass('tooltipstered')) return;

        $(item).tooltipster({
            trigger: 'hover',
            triggerOpen: {mouseenter: true, mouseover: true, click: true, tap: true, touchstart: true},
            triggerClose: {mouseleave: true,touchleave: true,scroll : true},
            delay: [500, 100],
            animation: 'fade',
            animationDuration: 300,
            interactive: true,
            debug: false,
            content: '<img src="/template/img/anim.gif" alt="">',
            functionBefore: function(instance, helper){

                let origin		= $(helper.origin);
                let act			= origin.data('hint_load');
                let	dataOptions = origin.attr('data-tooltipster');

                if(dataOptions){
                    dataOptions = JSON.parse(dataOptions);

                    $.each(dataOptions, function(name, option){
                        instance.option(name, option);
                    });
                }

                if(origin.data('loaded') !== true){
                    $.get('/ajax/hint_load', {act: act}, function(d){
                        let data = ParseResp(d);
                        if(data){
                            instance.content(data.data.content);
                            origin.data('loaded', true);
                            hintsInit();
                        }
                    });
                }
            },
            functionReady: function(instance, helper){
                $('[data-tooltip=active]').removeAttr('data-tooltip');
                $(helper.origin).attr('data-tooltip', 'active');
                hintsInit();
            }
        });

    })



}

export {hintsInit}